import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/secretarias',
		component: Base,
		children: [
			{
				path: '',
				name: 'SecretariasList',
				component: List,
				meta: {
					path: '/site/secretarias',
					pai: 'Site',
					title: 'Admin - Secretarias',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Secretarias',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'SecretariasNovo',
				component: Form,
				meta: {
					path: '/site/secretarias',
					pai: 'Site',
					title: 'Admin - Secretarias - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Secretarias',
						class: '',
						active: false,
						url: '/site/secretarias'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'SecretariasEditar',
				component: Form,
				meta: {
					path: '/site/secretarias',
					pai: 'Site',
					title: 'Admin - Secretarias - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Secretarias',
						class: '',
						active: false,
						url: '/site/secretarias'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]